import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewChild,
    ViewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomEventCommand, CustomPlaceCommand } from '../../../commands/hub/custom.event.command';
import AuthResponse = facebook.AuthResponse;
import {
    CustomDefaultPlaceCategory,
    VisitorCalendarActionCommand,
    VisitorStyleCommand,
} from '../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../../../commands/visitor/all.frontend.settings.command';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { BaseComponent } from '../../../common/components/base.component';
import { FacebookLoginButtonComponent } from '../../../common/components/facebook.login.button/facebook.login.button.component';
import { PlaceCategory } from '../../../common/constants/constant';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { bindFunctionsToThis, clone } from '../../../common/extensions';
import { ModalService } from '../../../common/services/modal.service';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { VisitorApiService } from '../../../services/visitor.api.service';
import {
    AllFrontendSettingsStore,
    VisitorCalendarStore,
    VisitorStyleStore,
} from '../../../stores/visitor.calendar.store';
import { VisitorComponent } from '../visitor.component';
import { DateFieldComponent } from '../../../common/components/date.time.field/date.field.component';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { EditorChoiceStore } from '../../../stores/hub.calendar.store';
import { EditorChoiceDataSource } from '../../../models/hub/hub.event';
import { EventTimeService } from '../../../services/event.time.service';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { PlaceType } from '../../hub/place.category/customize.place.category.component';
import { DisplayingOn } from '../../hub/side.bar/hub.side.bar.component';
import { NestedMenusComponent } from '../../../common/components/nested.menu/nested.menu.component';
import { EventFilterComponent } from '../event.filter/event.filter.component';
import { CustomDefaultPlaceCategoryAccordionComponent } from '../../hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { CustomPlaceBtnComponent } from '../custom.place.btn/custom.place.btn.component';
import { PlaceService } from '../../../services/place.service';
import { Location } from '@angular/common';

@Component({
    selector: 'ig-top-bar',
    templateUrl: './visitor.top.bar.component.html',
    styleUrls: ['./visitor.top.bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class VisitorTopBarComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
    public hubName: string;
    public authResponse: AuthResponse;
    public isHideEditorChoice: boolean;
    public searchText: string;
    public searchFormGroup: FormGroup;
    public dateFormGroup: FormGroup;
    public from: Date = null;
    public to: Date = null;
    public fromForSelector: Date;
    public toForSelector: Date;
    public category: string;
    public categoryId: string;
    public menuType: string;
    public command = new VisitorCalendarActionCommand();
    public dateFilterType: string;
    public simpleMenu = false;
    public searchParam = {
        searchTimeout: null,
        debounceTime: 500,
        isSearching: false,
    };
    @ViewChild('loginWithFBBtn') public loginWithFBBtn: FacebookLoginButtonComponent;
    @ViewChild('manualAccordion') public manualAccordion: AccordionComponent;
    @ViewChild('customDefaultPlaceBtn') public customDefaultPlaceBtn: NestedMenusComponent;
    @ViewChild('customPlaceAccordion') public customPlaceAccordion: AccordionComponent;
    @ViewChild('customDefaultPlaceAccordion')
    public customDefaultPlaceAccordion: CustomDefaultPlaceCategoryAccordionComponent;
    @ViewChild('customEventAccordion') public customEventAccordion: AccordionComponent;
    @ViewChild('eventDateAccordion') public eventDateAccordion: AccordionComponent;
    @ViewChild('from') public fromDateField: DateFieldComponent;
    @ViewChild('to') public toDateField: DateFieldComponent;
    @ViewChild('topBar') public topBar: ElementRef;
    @ViewChild('position') public positionWrap: ElementRef;
    @ViewChild('eventFilter') public eventFilter: EventFilterComponent;
    @ViewChild('customPlaceBtn') public customPlaceBtn: CustomPlaceBtnComponent;
    @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
    public customEvents: any[];
    public customPlaces: any[];
    public selectedCustomEvent = new CustomEventCommand();
    public selectedCustomPlace = null;
    public featuresToggle = new HubVisitorFeatureToggle();
    public toggleAndSource = new HubVisitorToggleDataSource();
    public loadingToggles = true;
    public editorChoiceText = '';
    public selectedEvents = null;
    public isEditorChoice: boolean | null = null;
    public customDefaultPlaceCategory: CustomDefaultPlaceCategory = null;
    public initialCustomDefaultPlaceCategory: {
        categoryList: string[];
        categoryString: string;
        category: PlaceType;
    };

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private visitorCalendarStore: VisitorCalendarStore,
        private formBuilder: FormBuilder,
        private parent: VisitorComponent,
        private editorChoiceStore: EditorChoiceStore,
        private visitorApiService: VisitorApiService,
        private visitorStyleStore: VisitorStyleStore,
        private allFrontendSettingsStore: AllFrontendSettingsStore,
        private location: Location,
        private modalService: ModalService
    ) {
        super({ activatedRoute });
        bindFunctionsToThis(this);
    }

    public ngOnInit() {
        let { hubName, category, menuType, customPlaceBtnId } = this.allRouteParams;
        this.hubName = hubName;
        this.category = category || 'All';
        this.menuType = menuType || null;
        this.simpleMenu = menuType === 'simple';
        this.categoryId = customPlaceBtnId || null;

        this.command.queryCommand.category = category;
        this.visitorCalendarStore.actionCommand.next(this.command);

        this.visitorCalendarStore.actionCommand
            .takeUntil(this.isDestroyed)
            .subscribe((command: VisitorCalendarActionCommand) => {
                this.command = command;
                console.log('command in topbar', this.command);
                this.setQueryCommand();

                this.setSelectedDefaultCategoryFilterBackFromMapView();

                // custom place btn selected
                if (this.command.queryCommand.customPlaceBtnText) {
                    this.customPlaceBtn &&
                        this.customPlaceBtn.setFilter(
                            this.command.queryCommand.customPlaceBtnText,
                            this.command.queryCommand.choice
                        );
                } else {
                    this.customPlaceBtn && this.customPlaceBtn.clearFilter();
                }
            });

        this.searchFormGroup = this.formBuilder.group({
            searchText: [null],
        });

        this.dateFormGroup = this.formBuilder.group({
            from: [null, [Validators.required]],
            to: [null, [Validators.required]],
        });

        this.loadingToggles = true;
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe((command: AllFrontendSettingsCommand) => {
                if (command.customSettings) {
                    this.customEvents = command.customSettings.customEvents || null;
                    this.customPlaces = command.customSettings.customPlaces || null;
                    this.isHideEditorChoice = command.customSettings.isHideEditorChoice || false;
                    //this.visitorPromotionImage = command.customSettings.visitorPromotionImage || null;

                    this.setCustomDefaultPlaceCategory(command.customSettings.customDefaultPlaceCategory);
                }
                if (command.toggle) {
                    this.featuresToggle = command.toggle;
                    this.toggleAndSource.toggle = this.featuresToggle;
                    this.toggleAndSource.dataSource = command.dataSource;
                    this.loadingToggles = false;
                }
            });

        this.setWidth();
        this.editorChoiceTextHandler();
    }

    private setQueryCommand() {
        !!this.activatedRoute.firstChild &&
            this.activatedRoute.firstChild.url.subscribe((x) => {
                // this.command.isEventCalendar = (x[0].path === routeConfigs.visitor.eventCalendar.path || routeConfigs.visitor.eventDetailsModal.path.indexOf(x[0].path) >= 0);
                if (
                    x[0].path === routeConfigs.visitor.eventCalendar.path ||
                    x[0].path === routeConfigs.visitor.editorChoice.path ||
                    routeConfigs.visitor.createEvent.path.indexOf(x[0].path) >= 0 ||
                    routeConfigs.visitor.customEvent.path.indexOf(x[0].path) >= 0 ||
                    routeConfigs.visitor.eventDetailsModal.path.indexOf(x[0].path) >= 0
                ) {
                    this.command.isEventCalendar = true;
                } else {
                    this.command.isEventCalendar = false;
                }

                if (
                    x[0].path === routeConfigs.visitor.editorChoice.path ||
                    x[0].path === routeConfigs.visitor.placeEditorChoice.path
                ) {
                    this.command.queryCommand.choice = true;
                }
                // else {
                //     this.command.queryCommand.choice = false;
                // }
            });
    }

    public ngAfterViewInit() {
        window.addEventListener('click', this.closeAccordion);
    }

    public ngOnDestroy() {
        window.removeEventListener('click', this.closeAccordion);
    }

    public editorChoiceTextHandler() {
        this.editorChoiceStore.infoCommand
            .takeUntil(this.isDestroyed)
            .subscribe((editorChoice: EditorChoiceDataSource) => {
                if (!!this.command.isEventCalendar) {
                    this.editorChoiceText = editorChoice.editorChoiceForEvent;
                } else {
                    this.editorChoiceText = editorChoice.editorChoiceForPlace;
                }
            });
    }

    private setSelectedDefaultCategoryFilterBackFromMapView() {
        // get the selected category back from map view
        if (this.command.queryCommand.category) {
            if (this.menuType !== 'custom') {
                this.category = this.command.queryCommand.category;
                this.setCustomDefaultPlaceFilter(this.category);
            } else {
                setTimeout(() => {
                    try {
                        const str = localStorage.getItem(localStorageKeys.selectedPlaceCategory);
                        const data = str ? JSON.parse(str) : { title: this.command.queryCommand.category };
                        if (data) {
                            this.setCustomDefaultPlaceFilter(data.title);
                        }
                    } catch (error) {
                        console.log('Not parse selectedPlaceCategory', error.message);
                    }
                }, 1600);
            }
        }
    }

    private setCustomDefaultPlaceFilter(title) {
        title = title || '';
        title = title.toLowerCase() === 'all' ? '' : title;
        this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.setFilter(title);
    }

    /**
     * if visit a custom default place category url, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
     * */
    private setCustomDefaultPlaceCategory(customDefaultPlaceCategory) {
        if (this.menuType === 'custom') {
            // this.category is the custom default place category id, e.g., 62a46ea3e6ad6016f05245ff
            const data = PlaceService.getCustomDefaultCategoryFromURL(this.category, customDefaultPlaceCategory);
            if (data) {
                this.categoryId = this.category;
                this.category = data.category.title;
                // this.customDefaultPlaceCategory = data.customDefaultPlaceCategory;
                this.customDefaultPlaceCategory = customDefaultPlaceCategory;
                this.command.queryCommand.categoryList = data.categoryList;
                const categoryString = JSON.stringify(data.category);
                this.initialCustomDefaultPlaceCategory = {
                    category: data.category,
                    categoryString: categoryString,
                    categoryList: data.categoryList,
                };
                // for map view
                localStorage.setItem(localStorageKeys.selectedPlaceCategory, categoryString);
            }
        } else {
            this.customDefaultPlaceCategory = customDefaultPlaceCategory;
        }
        this.visitorCalendarStore.actionCommand.next(this.command);
    }

    public get isShowThingsToDo() {
        return (
            !this.loadingToggles &&
            (this.featuresToggle.placeCategory.activity ||
                this.featuresToggle.placeCategory.art ||
                this.featuresToggle.placeCategory.outdoor ||
                this.featuresToggle.placeCategory.entertainment)
        );
    }

    public closeAccordion(target?) {
        if (
            target &&
            target.srcElement &&
            (target.srcElement.className.indexOf('md2-datepicker') >= 0 ||
                target.srcElement.className.indexOf('md2-calendar') >= 0 ||
                target.srcElement.className.indexOf('ng-tns') >= 0 ||
                target.srcElement.className.indexOf('value') >= 0)
        ) {
            return;
        }
        this.eventDateAccordion && this.eventDateAccordion.close();
        this.customEventAccordion && this.customEventAccordion.close();
        this.manualAccordion && this.manualAccordion.close();
        this.customPlaceAccordion && this.customPlaceAccordion.close();
        this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.close();
        this.customPlaceBtn && this.customPlaceBtn.close();
    }

    public get isEventEnabled() {
        return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
    }

    public viewChange() {
        let command = new VisitorCalendarActionCommand();
        this.command.isMapView = !this.command.isMapView;
        command = this.command;

        let path = { path: '' };
        if (command.isMapView) {
            if (this.command.isEventCalendar) {
                path = routeConfigs.visitor.eventMap;
            } else {
                path = routeConfigs.visitor.placeMap;
            }
        } else {
            if (this.command.isEventCalendar) {
                path = routeConfigs.visitor.eventCalendar;
            } else {
                path = routeConfigs.visitor.placeCalendar;
            }
        }
        if (this.command.isEventCalendar) {
            this.router.navigateByUrl(
                getRouteUrl(path, {
                    hubName: this.hubName,
                }),
                { skipLocationChange: this.noChangeUrlWhenRedirect }
            );
        } else {
            // custom-places is the custom place button place category
            console.log('location--', this.location.path());

            if (this.menuType === 'custom-places' || this.location.path().includes('/custom-places/')) {
                console.log('path', path);
                console.log('this.categoryId', this.categoryId);

                this.router.navigateByUrl(
                    getRouteUrl(path, {
                        hubName: this.hubName,
                        category: 'custom-places',
                        menuType: this.categoryId,
                    }),
                    { skipLocationChange: this.noChangeUrlWhenRedirect }
                );
            } else {
                // menuType = custom is the custom default place category
                const cate = this.customDefaultPlaceCategory.useDefault
                    ? PlaceCategory.getPlaceCategoryKey(this.category)
                    : this.menuType === 'custom'
                    ? this.categoryId
                    : 'All';
                this.router.navigateByUrl(
                    getRouteUrl(path, {
                        hubName: this.hubName,
                        category: cate,
                        menuType: this.menuType || (this.simpleMenu ? 'simple' : 'normal'),
                    }),
                    { skipLocationChange: this.noChangeUrlWhenRedirect }
                );
            }
        }

        this.visitorCalendarStore.actionCommand.next(command);
    }

    public close() {
        this.onClose.emit();
    }

    public gotoEventCalendar() {
        this.searchText = null;
        this.category = 'All';
        let path = this.command.isMapView ? routeConfigs.visitor.eventMap : routeConfigs.visitor.eventCalendar;
        this.command.isEventCalendar = true;
        this.command.queryCommand.category = 'All';
        this.command.queryCommand.choice = null;
        this.command.queryCommand.isCustom = null;
        this.command.queryCommand.feedId = null;
        this.command.queryCommand.from = null;
        this.command.queryCommand.to = null;
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.visitorStyleStore.styleCommand.next(new VisitorStyleCommand());

        this.router.navigateByUrl(
            getRouteUrl(path, {
                hubName: this.hubName,
            }),
            { skipLocationChange: this.noChangeUrlWhenRedirect }
        );
    }

    public gotoPlaceCalendar() {
        this.searchText = null;
        this.category = 'All';
        let path = this.command.isMapView ? routeConfigs.visitor.placeMap : routeConfigs.visitor.placeCalendar;
        this.command.isEventCalendar = false;
        this.command.queryCommand.category = 'All';
        this.command.queryCommand.from = null;
        this.command.queryCommand.to = null;
        this.command.queryCommand.choice = null;
        this.command.queryCommand.isCustom = null;
        this.command.queryCommand.feedId = null;
        this.visitorCalendarStore.actionCommand.next(this.command);

        let styleCommand = new VisitorStyleCommand();
        styleCommand.menuStyle.isSideBar = this.parent.allFrontendSettings.customSettings.menuStyle.isSideBar;
        // styleCommand.menuStyle.menuBarMode = this.parent.menuBarMode;
        this.visitorStyleStore.styleCommand.next(styleCommand);

        this.router.navigateByUrl(
            getRouteUrl(path, {
                hubName: this.hubName,
                category: this.category,
            }),
            { skipLocationChange: this.noChangeUrlWhenRedirect }
        );
    }

    public gotoTripPlanner() {
        let path = routeConfigs.tripPlanner.trip; //routeConfigs.visitor.trip;
        this.router.navigateByUrl(
            getRouteUrl(path, {
                hubName: this.hubName,
            }),
            { skipLocationChange: this.noChangeUrlWhenRedirect }
        );
    }

    public search($event?) {
        if ($event && $event.key === 'Tab') {
            return;
        }

        /**
         * search in all events, or with current filters?
         * */
        const isKeepFilter = false;
        if (!isKeepFilter) {
            this.customPlaceAccordion && this.customPlaceAccordion.clearFilter(null, false);
            this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
            this.selectedEvents = null;
            this.isEditorChoice = null;
            this.from = null;
            this.to = null;
            this.category = 'all';
            this.eventFilter && this.eventFilter.clearFilter();
        }

        let command = this.command;
        command.queryCommand.search = this.searchText || null;
        command.queryCommand.from = this.from;
        command.queryCommand.to = this.to;
        command.queryCommand.category = this.category;
        command.queryCommand.choice = this.isEditorChoice;
        command.queryCommand.selectedEvents = this.selectedEvents;
        command.queryCommand.customEventBtnText = null;
        command.queryCommand.dateFilterText = null;
        command.queryCommand.feedId = null;
        command.queryCommand.isCustom = null;

        if (!this.command.isEventCalendar) {
            command.queryCommand.from = null;
            command.queryCommand.to = null;
        }
        command.isEventCalendar = this.command.isEventCalendar;
        //this.visitorCalendarStore.actionCommand.next(command);

        if (this.searchParam.searchTimeout) {
            clearTimeout(this.searchParam.searchTimeout);
            this.searchParam.searchTimeout = setTimeout(() => {
                this.searchParam.isSearching = true;
                setTimeout(() => {
                    this.searchParam.isSearching = false;
                }, 3000);
                this.visitorCalendarStore.actionCommand.next(command);
            }, this.searchParam.debounceTime);
            return;
        }

        this.searchParam.searchTimeout = setTimeout(() => {
            this.searchParam.isSearching = true;
            setTimeout(() => {
                this.searchParam.isSearching = false;
            }, 2000);
            this.visitorCalendarStore.actionCommand.next(command);
        }, this.searchParam.debounceTime);
    }

    public filterPlace(category) {
        this.searchText = null;
        //category = PlaceCategory.getPlaceCategoryValue(category);

        let command = new VisitorCalendarActionCommand();
        command.isEventCalendar = false;
        command.queryCommand.choice = null;
        command.queryCommand.search = null;
        this.selectedCustomPlace = null;
        let path = this.command.isMapView ? routeConfigs.visitor.placeMap : routeConfigs.visitor.placeCalendar;

        if (category === 'selected') {
            command.queryCommand.isCustom = true;
            command.queryCommand.category = null;
            this.category = category;
            this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
            this.customPlaceBtn && this.customPlaceBtn.clearFilter();
            this.router.navigateByUrl(
                getRouteUrl(path, {
                    hubName: this.hubName,
                }),
                { skipLocationChange: this.noChangeUrlWhenRedirect }
            );
        } else {
            // custom default category from URL, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
            if (this.menuType === 'custom') {
                // all selected, load all categroyList
                command.queryCommand.categoryList = this.initialCustomDefaultPlaceCategory.categoryList;
                // for map view
                localStorage.setItem(
                    localStorageKeys.selectedPlaceCategory,
                    this.initialCustomDefaultPlaceCategory.categoryString
                );
            } else {
                this.category = category;
                command.queryCommand.category = category || null;
                this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
                this.customPlaceBtn && this.customPlaceBtn.clearFilter();
            }
            this.router.navigateByUrl(
                getRouteUrl(path, {
                    hubName: this.hubName,
                    category:
                        this.menuType === 'custom' ? this.categoryId : PlaceCategory.getPlaceCategoryKey(this.category),
                    menuType: this.menuType,
                }),
                { skipLocationChange: this.noChangeUrlWhenRedirect }
            );
        }
        this.visitorCalendarStore.actionCommand.next(command);
    }

    public selectCustomDefaultPlaceCategory($event: PlaceType) {
        console.log({ $event });
        this.command.isEventCalendar = false;
        this.command.queryCommand.feedId = null;
        this.command.queryCommand.category = $event ? $event.title : 'all';
        // this.command.queryCommand.categoryName = $event.title;
        this.command.queryCommand.categoryList = $event ? $event.categoryList : null;
        this.command.queryCommand.type = undefined;
        this.command.queryCommand.search = '';
        this.command.queryCommand.isCustom = undefined;

        // for map view
        localStorage.setItem(
            localStorageKeys.selectedPlaceCategory,
            JSON.stringify(this.command.queryCommand.categoryList)
        );

        this.visitorCalendarStore.actionCommand.next(this.command);

        // in order for calendar to load when currently showing submit place view
        this.router.navigateByUrl(
            getRouteUrl(routeConfigs.visitor.placeCalendar, {
                hubName: this.hubName,
                // category: this.menuType === 'custom' ? $event._id : 'All',
                category: $event._id,
                menuType: 'custom',
            }),
            { skipLocationChange: this.noChangeUrlWhenRedirect }
        );
        $event && this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.setFilter($event._id);
        !$event && this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
        this.customPlaceAccordion && this.customPlaceAccordion.clearFilter(null, false);
        this.customPlaceBtn && this.customPlaceBtn.clearFilter();
    }

    public customPlaceBtnSelected(command: CustomPlaceCommand) {
        console.log('customPlaceBtnSelected', command);

        this.menuType = 'custom-places';
        this.categoryId = command._id;

        this.category = 'All';
        this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.clearFilter();
    }

    public addEventsManually() {
        this.router.navigateByUrl(
            getRouteUrl(routeConfigs.visitor.createEvent, {
                hubName: this.hubName,
            }),
            { skipLocationChange: this.noChangeUrlWhenRedirect }
        );
    }

    public addPlacesManually() {
        this.router.navigateByUrl(
            getRouteUrl(routeConfigs.visitor.createPlace, {
                hubName: this.hubName,
            }),
            { skipLocationChange: this.noChangeUrlWhenRedirect }
        );
    }

    public setWidth() {
        setTimeout(() => {
            let topBarWidth = this.topBar.nativeElement.getBoundingClientRect().width;
            if (topBarWidth < 1470) {
                let headers = this.topBar.nativeElement.getElementsByClassName('ig-according-header');
                let spans = this.topBar.nativeElement.getElementsByClassName('mat-button-wrapper');
                let btns = this.topBar.nativeElement.getElementsByClassName('btn');
                let icons = this.topBar.nativeElement.querySelectorAll('.btn .mat-icon');

                for (let i = 0; i < spans.length; i++) {
                    (spans[i] as HTMLElement).style.fontSize = '12px';
                }
                for (let i = 0; i < headers.length; i++) {
                    (headers[i] as HTMLElement).style.fontSize = '12px';
                    (headers[i] as HTMLElement).style.paddingLeft = '8px';
                }
                for (let i = 0; i < btns.length; i++) {
                    (btns[i] as HTMLElement).style.paddingLeft = '8px';
                }
                for (let i = 0; i < icons.length; i++) {
                    (icons[i] as HTMLElement).style.right = '4px';
                }
            }
        });
    }

    @HostListener('window:load')
    onLoad() {
        console.log('is window:load');
        const start = window.performance.timing.domLoading;
        const end = window.performance.timing.domComplete;
        console.log('dom', end - start);

        const paint = window.performance.getEntriesByType('paint');
        const fp = paint.find((e) => e.name === 'first-paint').startTime;
        const fcp = paint.find((e) => e.name === 'first-contentful-paint').startTime;
        console.log(`fp: ${fp}, fcp: ${fcp}`);

        // let observer = new PerformanceObserver((list, obs) => {
        //     list.getEntries().forEach(x => {
        //         console.log(x);
        //     })
        // });
        // observer.observe({entryTypes: ['paint', 'resource', 'mark']});
        //
        // window.performance.mark('own');
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/top.bar/visitor.top.bar.component.ts